import { useGetSettingsQuery } from '@api/api';
import { DataLoadingProgress, GenericErrorPage } from '@components';
import { Suspense } from 'react';

export type SiteContentLoaderProps = {
  children?: React.ReactNode;
};

/**
 * Site Content Loader.
 * Load Site Settings before displaying any other content.
 * Settings are intercepted and saved in the app.slice extra reducer.
 */
export const SiteContentLoader = ({ children }: SiteContentLoaderProps) => {
  const { isLoading, isError } = useGetSettingsQuery(null);

  if (isLoading) return <DataLoadingProgress />;
  if (isError) return <GenericErrorPage />;

  return <Suspense fallback={<DataLoadingProgress />}>{children}</Suspense>;
};
